module.exports = __webpack_public_path__ + "img/redis.3f9e288.svg";